var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicalServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2685_9714",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    fill: "#009CA6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2685_9714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8331 30.0004H22.1665V25.0004H27.1665V21.6671H22.1665V16.6671H18.8331V21.6671H13.8331V25.0004H18.8331V30.0004ZM7.16646 36.6671C6.2498 36.6671 5.46535 36.341 4.81313 35.6887C4.1598 35.0354 3.83313 34.2504 3.83313 33.3337V13.3337C3.83313 12.4171 4.1598 11.6326 4.81313 10.9804C5.46535 10.3271 6.2498 10.0004 7.16646 10.0004H13.8331V6.66707C13.8331 5.75041 14.1598 4.96541 14.8131 4.31207C15.4654 3.65985 16.2498 3.33374 17.1665 3.33374H23.8331C24.7498 3.33374 25.5348 3.65985 26.1881 4.31207C26.8404 4.96541 27.1665 5.75041 27.1665 6.66707V10.0004H33.8331C34.7498 10.0004 35.5348 10.3271 36.1881 10.9804C36.8404 11.6326 37.1665 12.4171 37.1665 13.3337V33.3337C37.1665 34.2504 36.8404 35.0354 36.1881 35.6887C35.5348 36.341 34.7498 36.6671 33.8331 36.6671H7.16646ZM17.1665 10.0004H23.8331V6.66707H17.1665V10.0004Z",
    fill: "#009CA6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalServices);
export default __webpack_public_path__ + "static/media/medical_services.211f9e33.svg";
export { ForwardRef as ReactComponent };